var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ids-404-not-found",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"information"},[_c('p',[_vm._v("没有找到该页面")]),_c('p',[_c('span',[_vm._v("404 Not Found")])])])])
}]

export { render, staticRenderFns }